/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const BWHListType = {
    DEFAULT: '',
    VOD_BROWSE_MAIN: 'VOD_BROWSE_MAIN',
};

export const SCROLL_DIRECTION = {
    UP: 'UP' as TScrollDirection,
    DOWN: 'DOWN' as TScrollDirection,
    LEFT: 'LEFT' as TScrollDirection,
    RIGHT: 'RIGHT' as TScrollDirection,
};

type THorizontalItem = {
    listType: (typeof BWHListType)[keyof typeof BWHListType];
    listItems: Array<any>;
    isEmpty: boolean;
};

type TVerticalItem = {
    listTitle: string;
    displayTitle: string;
};

type TVerticalItems = Array<TVerticalItem>;

type TScrollDirection = 'DOWN' | 'LEFT' | 'RIGHT' | 'UP';

export type { THorizontalItem, TVerticalItem, TVerticalItems, TScrollDirection };
